module.exports = __webpack_public_path__ + "img/bgNotification.ad28d75e.svg";